import type ConversationSortOrder from 'owa-service/lib/contract/ConversationSortOrder';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

export default function getConversationSortOrderFromSettings(): ConversationSortOrder {
    // Replicate OM behavior on Teams mobile OPX
    if (isMiniHostAppFeatureEnabled('readOnlyReadingPane')) {
        return 'ChronologicalNewestOnBottom';
    }
    const userConfiguration = getUserConfiguration();
    const sortOrderFromOptions = userConfiguration.UserOptions.ConversationSortOrderReact;
    let conversationSortOrder: ConversationSortOrder;
    if (sortOrderFromOptions !== undefined && typeof sortOrderFromOptions === 'string') {
        // Convert string to enum
        conversationSortOrder = sortOrderFromOptions;
    } else {
        conversationSortOrder = sortOrderFromOptions as ConversationSortOrder;
    }
    return conversationSortOrder;
}
